import "./StainOrderGroup.css";

import classNames from "classnames";

import { LabOrder } from "pwapi";

import ActiveStainOrder from "./ActiveStainOrder";

type OrderGroupProps = {
  groupLabel: string;
  group: LabOrder[];
  currentBlock?: boolean;
  onCancelOrder: Function;
  hideStatusIcons?: boolean;
};

const StainOrderGroup = ({
  groupLabel,
  group,
  currentBlock,
  onCancelOrder,
  hideStatusIcons,
}: OrderGroupProps) => {
  return (
    <div
      className={classNames("StainOrderEntry", {
        StainOrderEntry__currentBlock: currentBlock,
      })}
    >
      <div className="StainOrderEntry__top">
        <strong>{groupLabel}</strong>
      </div>
      <div className="StainOrderEntry__bottom">
        {group
          .sort((a, b) =>
            (a.created_at || "").localeCompare(b.created_at || "", "en", {
              numeric: true,
              sensitivity: "base",
            })
          )
          .map((order) => (
            <ActiveStainOrder
              order={order}
              cancelOrder={onCancelOrder}
              key={`order_${order.id}`}
              hideStatusIcons={hideStatusIcons}
            />
          ))}
      </div>
    </div>
  );
};

export default StainOrderGroup;
